$(function() {
	// Register any recaptcha verification functions that are being used by the site.

	window.recaptchaSuccess = function (response, event) {
		let threshold = window.recaptchaDefaultThreshold ?? 0.5;
		if (response['score'] <= window.recaptchaDefaultThreshold) {
			$('.search-error').removeClass('-hide');
			$('.search-drawer > div.open').css('height', '150px');
			return;
		}

		// if this function was called as part of the form version
		// the event will be passed on so you can handle it as you please
		if(event){
			// in the case of a <form> submit event, this will "continue" the submission
			event.target.submit();
		}
	};
			
	window.recaptchaFailure = function (response, event) {
		// console.log(response);
		console.error('We could not verify the user with Google reCaptcha 3: '+response['error-codes'].join(','))
		$('.search-error').removeClass('-hide');
		$('.search-drawer > div.open').css('height', '150px');
	};
});